<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container
            class="fluid grid-list-xl"
            style="height: 100%;"
    >
        <v-layout class="row wrap">
            <v-flex class="xs3 sm6 md9 lg9" >
                <span >
                    {{ title }}
                </span>
            </v-flex>
            <v-flex class="xs9 sm6 md3 lg3">
                <v-text-field
                        placeholder="search"
                        solo
                        v-model="search"
                        prepend-inner-icon="search"
                        label="Search"
                        class="ma-0 hide-details"
                ></v-text-field>
            </v-flex>
        </v-layout>

        <v-layout class="row wrap">
            <v-flex class="xs12 sm12 md12 lg12">
                <v-data-table
                        :headers="headers"
                        :items="periodiccar_taskhistory"
                        :search="search"
                        :pagination.sync="pagination"
                        hide-actions
                        class="elevation-1"
                >
                    <template slot="items" slot-scope="items">
                        <td class="text-xs-left" style="white-space: pre-wrap;">{{ items.item.Action }}</td>
                        <td class="text-xs-left" style="white-space: pre-wrap;">{{ tool_app.dateformat(items.item.DateTime_Task, 'YYYY.MM.DD HH:mm:ss') }}</td>
                        <td class="text-xs-left" style="white-space: pre-wrap;">{{ items.item.AccountName }}</td>
                        <td class="text-xs-left" style="white-space: pre-wrap;">{{ items.item.TaskContent }}</td>
                        <td class="text-xs-left" style="white-space: pre-wrap;">{{ items.item.Description }}</td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>

<!--        <v-btn-->
<!--                color="success"-->
<!--                @click="getList()"-->
<!--        >getList</v-btn>-->

    </v-container>
</template>

<script>
  import tool_app from '../../utils/tool_app';

  function lg (...args) { tool_app.lg('PeriodicCar_TaskHistory] ', ...args); }

  let comp = null;
  export default {
    components: { },
    props: [ 'periodiccaridx' ],
    data () {
      return {
        tool_app: tool_app,
        title: '',
        search: '',
        periodiccar_taskhistory: [],

        pagination: {
          descending: true,
      sortBy: "DateTime_Task",
    },
        headers: [
          {text: 'Action', value: 'Action',
            sortable: false,},
          {text: '업무일', value: 'DateTime_Task'},
          {text: '업무자', value: 'AccountName'},
          {text: '업무내용', value: 'TaskContent'},
          {text: '비고', value: 'Description'},
        ],
      }
    },
    created: async function () {
      lg('created 1 ');
      comp = this;
      lg('created 2 comp.periodiccaridx: ', comp.periodiccaridx);

      tool_app.api(comp, 'SELECT * FROM T_PeriodicCar WHERE PeriodicCarIDX = ?;',
        [comp.periodiccaridx])
        .setShowProgressDialog()
        .send()
        .then(async (value) => {
          lg('created 2 value:', value.data.results);
          // 관리번호 {{ periodiccaridx }}
comp.title = '차량 정보 - '+value.data.results[0].CarNumber+' 관리번호: '+comp.periodiccaridx;
        })
        .catch((reason) => {
          tool_app.ex(new Error(JSON.stringify(reason, null, 2)));
        });

      comp.getList();
    },
    methods: {
      async getList() {
        lg('getList 1 ', comp.parkinglot_selected);
        tool_app.api(comp, 'SELECT * FROM T_PeriodicCar_TaskHistory WHERE IsExist = true AND PeriodicCarIDX = ?;',
          [ comp.periodiccaridx, ])
          .send()
          .then((value) => {
            // lg('getList 2 value:', value);
            lg('getList 2 value:', value.data.results);
            comp.periodiccar_taskhistory = value.data.results;
          })
          .catch((reason) => {
            tool_app.ex(new Error(JSON.stringify(reason, null, 2)));
          });
      },
    }
  }

</script>
